import { createSlice } from '@reduxjs/toolkit'

const initialStateValue = {
  authorized: false,

}

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialStateValue,
  reducers: {
    authenticate: (state) => {
      state.authorized = true
    },
    signout: (state) => {
      state.authorized = false
    },
  
   

  },
})

export const { authenticate, signout } = authSlice.actions

export default authSlice.reducer
